import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { ProviderTypeService } from '../../services/providerTypes/providerTypeService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage provider type fetching and transformation logic.
*     When companyId is set, list-select is filtered by that company (superadmin / explicit scope).
* ES: Hook para gestionar la lógica de obtención y transformación de tipos de proveedor.
*     Con companyId, el listado se filtra por esa compañía.
----------------------------------------------------------------------------------------*/

const useProviderTypes = (companyId?: string | null) => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchProviderTypes = useCallback(async (overrideCompanyId?: string | null) => {
        try {
            if (!userCan('list', 'provider_type')) return;
            const effectiveCompany =
                overrideCompanyId !== undefined ? overrideCompanyId : companyId;
            const service = new ProviderTypeService();
            const payload: Record<string, unknown> = { limit: 999999 };
            if (effectiveCompany) {
                payload.filter_filters = { company: effectiveCompany };
            }
            const response = await service.listForSelect(payload);
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('Error fetching provider types:', error);
        }
    }, [userCan, companyId]);

    useEffect(() => {
        fetchProviderTypes();
    }, [fetchProviderTypes]);

    const getProviderTypesList = () => {
        return data;
    };

    return { fetchProviderTypes, getProviderTypesList };
}

export default useProviderTypes;
